"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importStar(require("react"));
var Typography_1 = require("../Typography");
var theme_1 = require("../theme");
var context_1 = require("./context");
var RadioStyleView = styled_1.default.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n\n  border-radius: 50%;\n  width: ", ";\n  height: ", ";\n\n  min-width: ", ";\n  min-height: ", ";\n\n  :hover,\n  :focus {\n    border: 1px solid ", ";\n  }\n\n  border: 1px solid ", ";\n  transition: 0.2s all linear;\n\n  margin-top: 1px; /* Fix aligment with text */\n\n  :checked {\n    border: 5px solid ", ";\n  }\n"], ["\n  cursor: pointer;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n\n  border-radius: 50%;\n  width: ", ";\n  height: ", ";\n\n  min-width: ", ";\n  min-height: ", ";\n\n  :hover,\n  :focus {\n    border: 1px solid ", ";\n  }\n\n  border: 1px solid ", ";\n  transition: 0.2s all linear;\n\n  margin-top: 1px; /* Fix aligment with text */\n\n  :checked {\n    border: 5px solid ", ";\n  }\n"])), theme_1.theme.space.space20, theme_1.theme.space.space20, theme_1.theme.space.space20, theme_1.theme.space.space20, theme_1.theme.colors.actionPrimary, theme_1.theme.colors.n300, theme_1.theme.colors.actionPrimary);
var Label = styled_1.default.label(function (_a) {
    var disabled = _a.disabled;
    return "\n  cursor: ".concat(disabled ? 'default' : 'pointer', ";\n  display: inline-flex;\n  gap: ").concat(theme_1.theme.space.space12, ";\n  ").concat(disabled &&
        "\n    opacity: 50%; \n    pointer-events: none;\n    ", "\n");
});
var tabIndexValue = function (selected, value, index) {
    // if no value has been selected the first option should be have tabIndex = 0
    // https://www.w3.org/WAI/ARIA/apg/example-index/radio/radio-rating.html
    if (!selected && index == 0) {
        return 0;
    }
    if (selected == value) {
        return 0;
    }
    return -1;
};
var Radio = function (props) {
    var _a = (0, react_1.useContext)(context_1.RadioContext), selected = _a.selected, onChange = _a.onChange, groupDisabled = _a.disabled;
    var checked = selected === props.value;
    var isDisabled = groupDisabled || props.disabled;
    var tabIndex = tabIndexValue(selected, props.value, props.index);
    return (react_1.default.createElement(Label, { disabled: isDisabled },
        react_1.default.createElement(RadioStyleView, { type: "radio", checked: checked, "aria-checked": checked, onChange: function () { return !isDisabled && onChange(props.value); }, disabled: isDisabled, role: "radio", tabIndex: tabIndex, "aria-label": props.ariaLabel }),
        react_1.default.createElement(Typography_1.Paragraph, null, props.children)));
};
exports.Radio = Radio;
var templateObject_1;
//# sourceMappingURL=Radio.js.map